// Listados paginados en la base de datos (25 por página), para tablas grandes (ver ESTANDAR_LISTADOS.md).
// La vista debe definir:
//   - data: isLoading (overlay de carga) y su objeto de filtros
//   - endpointListado (computed o data): URL del API, p. ej. '/gestion-costo-aereo'
//   - parametrosFiltro(): filtros para el API, p. ej. { destino: '…', tipo_envio: '…' }
// Uso en la plantilla:
//   <tr v-for="item in registros"> …
//   <PaginacionListado :pagina="pagina" :total-paginas="totalPaginas" :total="totalRegistros"
//     :por-pagina="porPagina" :en-pagina="registros.length" :cargando="isLoading" @cambiar="cambiarPagina" />
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      registros: [],
      pagina: 1,
      porPagina: 25,
      totalPaginas: 1,
      totalRegistros: 0,
    }
  },
  methods: {
    async cargarListado() {
      this.isLoading = true
      try {
        const { data } = await axios.get(this.endpointListado, { params: { ...this.parametrosFiltro(), page: this.pagina } })
        // Si la página quedó fuera de rango (p. ej. tras eliminar el último registro de la última página)
        if (data.data.length === 0 && data.total > 0 && this.pagina > data.last_page) {
          this.pagina = data.last_page
          return this.cargarListado()
        }
        this.registros = data.data
        this.totalPaginas = data.last_page
        this.totalRegistros = data.total
      } catch (error) {
        console.error('Error al cargar el listado:', error)
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo cargar la información. Intenta nuevamente.' })
      } finally {
        this.isLoading = false
      }
    },
    aplicarFiltros() {
      this.pagina = 1
      return this.cargarListado()
    },
    cambiarPagina(n) {
      this.pagina = n
      this.cargarListado()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // Todos los registros que cumplen los filtros (para Exportar)
    async todosLosRegistros() {
      const { data } = await axios.get(this.endpointListado, { params: this.parametrosFiltro() })
      return data
    },
  },
}
